import type { FlightContext } from "@checkout/states/Products";
import { getObjectKeysAsObject } from "../../../helpers";
import type { CartContext } from "../context";
import { CartState } from "../types";

export const guards = {
  hasNoAction: (ctx: CartContext, _event: unknown) =>
    !ctx[CartState.cartFulfill].pendingInteractive ||
    !ctx[CartState.cartFulfill].pendingInteractive.actions ||
    ctx[CartState.cartFulfill].pendingInteractive.actions.length === 0,

  hasNoUserAction: (ctx: CartContext, _event: unknown) =>
    !ctx[CartState.cartFulfill].userAction,

  isRyanAir: (context: FlightContext, _event: unknown) => {
    return context.flightShop.tripDetails.slices.some((s) =>
      s.segmentDetails.some((seg) => seg.airlineCode === "FR")
    );
  },
};

export const GuardTypes = getObjectKeysAsObject(guards);
